import {
  ComplaintsNotesDocument,
  DeleteComplaintsNoteDocument,
  DeleteComplaintsNoteMutation,
  DeleteComplaintsNoteMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteComplaintsNote = () => {
  const [executeMutation, { loading }] = useMutation(DeleteComplaintsNoteDocument, {
    extractorFn: (data: DeleteComplaintsNoteMutation) =>
      data.complaintsMutations.deleteComplaintsNote,
  })

  const deleteComplaintsNote = async (variables: DeleteComplaintsNoteMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [ComplaintsNotesDocument],
      awaitRefetchQueries: true,
    })
  }

  return {
    deleteComplaintsNote,
    loading,
  }
}
